module.exports = __webpack_public_path__ + "static/trusted-choice-logo-9ed9ef8d3f1b9a4ca1bca8c5ad6abdc3.svg";